import { render, staticRenderFns, recyclableRender, components } from "./node.vue?vue&type=template&id=35a45afb&filter-modules=eyJoYW5kbGVyIjp7InR5cGUiOiJzY3JpcHQiLCJjb250ZW50IjoiLy8g6KGM5YaF5qCH562%2B5YiX6KGoXG52YXIgaW5saW5lVGFncyA9IHtcbiAgYWJicjogdHJ1ZSxcbiAgYjogdHJ1ZSxcbiAgYmlnOiB0cnVlLFxuICBjb2RlOiB0cnVlLFxuICBkZWw6IHRydWUsXG4gIGVtOiB0cnVlLFxuICBpOiB0cnVlLFxuICBpbnM6IHRydWUsXG4gIGxhYmVsOiB0cnVlLFxuICBxOiB0cnVlLFxuICBzbWFsbDogdHJ1ZSxcbiAgc3BhbjogdHJ1ZSxcbiAgc3Ryb25nOiB0cnVlLFxuICBzdWI6IHRydWUsXG4gIHN1cDogdHJ1ZVxufVxuLyoqXG4gKiBAZGVzY3JpcHRpb24g5Yik5pat5piv5ZCm5Li66KGM5YaF5qCH562%2BXG4gKi9cbm1vZHVsZS5leHBvcnRzID0ge1xuICBpc0lubGluZTogZnVuY3Rpb24gKHRhZ05hbWUsIHN0eWxlKSB7XG4gICAgcmV0dXJuIGlubGluZVRhZ3NbdGFnTmFtZV0gfHwgKHN0eWxlIHx8ICcnKS5pbmRleE9mKCdkaXNwbGF5OmlubGluZScpICE9PSAtMVxuICB9XG59Iiwic3RhcnQiOjU2NTksImF0dHJzIjp7Im1vZHVsZSI6ImhhbmRsZXIiLCJsYW5nIjoid3hzIn0sImVuZCI6NjA5NX19&"
var renderjs
import script from "./node.vue?vue&type=script&lang=js&"
export * from "./node.vue?vue&type=script&lang=js&"
import style0 from "./node.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

/* custom blocks */
import block0 from "./node.vue?vue&type=custom&index=0&blockType=script&module=handler&lang=wxs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "uni_modules/mp-html/components/mp-html/node/node.vue"
export default component.exports